<div class="enc-id-modal-component" id="encIdtModal">
	<app-white-verification-modal
		(action)="getAction($event)"
		[title]="title"
		[showCloseIcon]="true"
		[showButtons]="showButtons">
		<ng-container>
			<div>
				<p>
					We need additional information to complete your activation. Please contact member services at 800.362.8671 or
					<a class="link" href="mailto:MemberServices@ehe.health"><b>MemberServices&#64;ehe.health</b></a
					>.
				</p>
			</div>
		</ng-container>
	</app-white-verification-modal>
</div>
<app-ehe-spinner></app-ehe-spinner>
